import Vue from 'vue'
import VueLodash from 'vue-lodash'

const options = {
    name: 'lodash'
} // customize the way you want to call it

Vue.use(VueLodash, options) // options is optional



// WEBPACK FOOTER //
// ./src/bibliotecas/vue/vuelodash.js